import { combineReducers } from 'redux';

import filesReducer, { FilesState } from './ducks/file';
import groupsReducer, { GroupsState } from './ducks/group';
import settingsReducer, { SettingsState } from './ducks/settings';
import uploadReducer, { UploadState } from './ducks/upload';

export type GlobalState = {
  apps: {
    appManagement: {
      files: FilesState,
      groups: GroupsState,
      settings: SettingsState,
      upload: UploadState,
    }
  }
}

export default combineReducers({
  files: filesReducer,
  groups: groupsReducer,
  settings: settingsReducer,
  upload: uploadReducer,
});
